
import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { UserProfile } from "@/components/admin/UserProfile";
import { AdminNavigationMenu } from "@/components/admin/AdminNavigationMenu";

const AdminNavbar = () => {
  return (
    <div className="bg-[#1e3a8a] text-white border-b border-blue-800">
      <div className="container py-3">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <Link to="/">
                <div className="h-16 w-16 rounded-full bg-white flex items-center justify-center overflow-hidden">
                  <img
                    src="/lovable-uploads/47f7a40a-1652-4194-97ca-60d534629618.png"
                    alt="SPO Logo"
                    className="h-full w-full object-contain"
                  />
                </div>
              </Link>
            </div>
            
            {/* Mobile profile dropdown */}
            <div className="flex items-center gap-3 md:hidden">
              <UserProfile isMobile />
            </div>
          </div>
          
          <div className="flex flex-1 justify-between items-center mt-4 md:mt-0">
            <AdminNavigationMenu />
            
            {/* Desktop profile dropdown */}
            <div className="hidden md:flex items-center">
              <UserProfile />
            </div>
          </div>
        </div>
        <Separator className="mt-2 bg-blue-700" />
      </div>
    </div>
  );
};

export default AdminNavbar;
